import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Invitations & Cards - INGAZ Print";

function Invitations() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          {/* Product Details Section */}
          <section className="product-details-section">
            <div className="product-container">
              {/* Left: Product Image Gallery */}
              <ProductGallery alt="Invitations" images={[asset('assets/invitation_hero_1770051376119.png'), asset('assets/invitation_stack_1770051401160.png'), asset('assets/invitation_envelope_1770051421790.png'), asset('assets/invitation_detail_1770051447363.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Invitations" data-ar="الدعوات">Invitations</h1>
                <p className="product-description" data-en="Elegant invitations and post cards on premium paper stocks." data-ar="دعوات وبطاقات بريدية أنيقة على ورق فاخر.">Elegant invitations and post cards on premium paper
                  stocks.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Premium feel for special occasions" data-ar="إحساس فاخر للمناسبات الخاصة">
                      Premium feel for special occasions</li>
                    <li data-en="Wide range of luxury paper stocks" data-ar="مجموعة واسعة من الأوراق الفاخرة">
                      Wide range of luxury paper stocks</li>
                    <li data-en="Custom sizes and envelope options" data-ar="أحجام مخصصة وخيارات مظاريف">
                      Custom sizes and envelope options</li>
                    <li data-en="High-resolution printing for intricate designs" data-ar="طباعة عالية الدقة للتصاميم المعقدة">
                      High-resolution printing for intricate designs</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Wedding Invites" data-ar="دعوات الزفاف">Wedding Invites</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/bag.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Corporate Events" data-ar="فعاليات الشركات">Corporate Events</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Thank You Cards" data-ar="بطاقات الشكر">Thank You Cards</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/calendar.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Save the Date" data-ar="تذكير بالميعاد">Save the Date</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          {/* Configuration Section */}
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Invitation" data-ar="قم بتكوين دعوتك">Configure Your Invitation</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={50} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="A5" data-dims="148x210">A5<br /><span>148x210</span></div>
                    <div className="size-option" data-size="A6" data-dims="105x148">A6<br /><span>105x148</span></div>
                    <div className="size-option" data-size="Custom" data-dims="Custom"><span data-en="Custom" data-ar="مخصص">Custom</span><br /><span>LxW</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type */}
                <div className="config-group">
                  <label data-en="Paper Type" data-ar="نوع الورق">Paper Type</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="couche-300" data-en="Couche 300 gsm" data-ar="كوشيه 300 جم">Couche 300 gsm
                      </option>
                      <option value="fabriano" data-en="Fabriano" data-ar="فابريانو">Fabriano</option>
                      <option value="textured" data-en="Textured paper" data-ar="ورق نسيجي">Textured paper</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printing Sides */}
                <div className="config-group">
                  <label data-en="Printing sides" data-ar="الجوانب المطبوعة">Printing sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single">
                      <span data-en="Single Side" data-ar="جانب واحد">Single Side</span>
                    </div>
                    <div className="side-option" data-sides="double">
                      <span data-en="Double Sides" data-ar="جانبان">Double Sides</span>
                    </div>
                  </div>
                </div>
                {/* Lamination */}
                <div className="config-group">
                  <label data-en="Lamination" data-ar="التغليف">Lamination</label>
                  <select id="lamination" style={{width: '100%', padding: 12, borderRadius: 10, border: '1px solid #e5e7eb'}}>
                    <option value="none" data-en="None" data-ar="لا شيء">None</option>
                    <option value="matt-one" data-en="Matt Cellophane [One side]" data-ar="سيلوفان غير لامع [جانب واحد]">Matt
                      Cellophane [One side]</option>
                    <option value="matt-both" data-en="Matt Cellophane [Both sides]" data-ar="سيلوفان غير لامع [جانبان]">Matt
                      Cellophane [Both sides]</option>
                    <option value="gloss-one" data-en="Gloss Cellophane [One side]" data-ar="سيلوفان لامع [جانب واحد]">Gloss
                      Cellophane [One side]</option>
                    <option value="gloss-both" data-en="Gloss Cellophane [Both sides]" data-ar="سيلوفان لامع [جانبان]">Gloss
                      Cellophane [Both sides]</option>
                  </select>
                </div>
                {/* Finishing */}
                <div className="config-group">
                  <label data-en="Finishing" data-ar="تشطيب">Finishing</label>
                  <div className="lamination-options" style={{flexWrap: 'wrap'}}>
                    <label className="radio-option">
                      <input type="radio" name="finishing" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="finishing" defaultValue="foil" />
                      <span data-en="Foil stamping" data-ar="بصمة فويل">Foil stamping</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="finishing" defaultValue="embossing" />
                      <span data-en="Embossing" data-ar="حفر (Embossing)">Embossing</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="finishing" defaultValue="spot-uv" />
                      <span data-en="Spot UV" data-ar="سبوت UV">Spot UV</span>
                    </label>
                  </div>
                  {/* Finishing Notes */}
                  <div className="config-group" style={{marginTop: 8}}>
                    <label htmlFor="finishingNotes" data-en="Finishing Notes" data-ar="ملاحظات التشطيب">Finishing Notes</label>
                    <textarea id="finishingNotes" placeholder="Describe the areas to have Spot UV, Embossing or Foil Stamping and whether on one side or two sides" rows={3} data-placeholder-en="Describe the areas to have Spot UV, Embossing or Foil Stamping and whether on one side or two sides" data-placeholder-ar="صف المناطق المراد تطبيق Spot UV أو الحفر أو بصمة الفويل عليها وما إذا كانت على جانب واحد أو جانبين" defaultValue={""} />
                  </div>
                </div>
                {/* Score */}
                <div className="config-group">
                  <label data-en="Score" data-ar="الحز (Score)">Score</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="score" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="score" defaultValue={1} />
                      <span data-en="1 Score" data-ar="حز واحد">1 Score</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="score" defaultValue="2-parallel" />
                      <span data-en="2 Parallel-Scores" data-ar="حزان متوازيان">2 Parallel-Scores</span>
                    </label>
                  </div>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                {/* Upload Design Files & Notes... */}
                <div className="config-group">
                  <label data-en="Upload Design Files" data-ar="رفع ملفات التصميم">Upload Design Files</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here
                        or browse</p>
                      <input type="file" id="fileInput" multiple style={{display: 'none'}} />
                    </div>
                  </div>
                </div>
                <NotesField />
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize">A5</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Paper:" data-ar="الورق:">Paper:</span>
                    <span className="summary-value" id="summaryPaper">Couche 300 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Sides:" data-ar="جوانب الطباعة:">Sides:</span>
                    <span className="summary-value" id="summarySides">Single Side</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Finishing:" data-ar="التشطيب:">Finishing:</span>
                    <span className="summary-value" id="summaryFinish">None</span>
                  </div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
              </div>
            </div>
          </section>
          {/* Footer ... */}
          <SiteFooter />
        </main>
    </>
  );
}

export default Invitations;
